import React from 'react';
import NavbarComponent from '../HomePage/NavBarComponent';
import { Outlet, useLocation } from 'react-router-dom';
import FooterSection from './FooterSection';

const LayoutHome = () => {
  const location = useLocation();

  // Check if current page is home page
  const isHomePage = location.pathname === '/';

  return (
    <div className="h-full bg-[#121316] flex flex-col min-h-screen max-w-[100vw] overflow-hidden relative">
      <NavbarComponent isHomePage={isHomePage} />
      <main className="flex-1">
        <Outlet />
      </main>
      <FooterSection />
    </div>
  );
};

export default LayoutHome;
